/** sha256 of bytes as lowercase hex, with the Web Crypto API (browser and Node ≥ 20). */
export async function sha256Hex(data: Uint8Array): Promise<string> {
  const digest = await globalThis.crypto.subtle.digest("SHA-256", data as Uint8Array<ArrayBuffer>);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, "0")).join("");
}

/**
 * Identity of a deposit's content whatever its order: sha256 of the sorted image
 * hashes joined by "\n". Computed the same way by public.start_deposit, so the
 * database, not the browser, decides what an exact duplicate is.
 */
export async function contentFingerprint(imageSha256: string[]): Promise<string> {
  return sha256Hex(new TextEncoder().encode([...imageSha256].sort().join("\n")));
}

/** Where a stored original lives: content-addressed, one object per distinct content. */
export const storagePath = (sha256: string) => `files/${sha256}`;
